import { IAccountMappingTemplateGroup, SortedMappingItem } from '@modeso/types__aumico-lib-annualreport-be';

export interface IGatheringSortedItem {
    visitSortedItems(sortedItem: SortedMappingItem): void;
    visitGroups(group: IAccountMappingTemplateGroup): void;
}
